import { AdvertEntity } from '../../domain/entities/Advert';
import { AdvertTitle } from '../../domain/value-objects/AdvertTitle';

// API shapes (temporary)
export interface AdvertAPIModel { uuid: string; id: number; title: string; description: string; accountId: number; createdAt: string; updatedAt: string; attachments?: { id: string; url: string; type: string; position: number; }[]; }
export interface ListAdvertsAPIResponse { adverts: AdvertAPIModel[]; pagination: { page: number; perPage: number; total: number; }; }

export const mapApiToEntity = (api: AdvertAPIModel): AdvertEntity => {
  return AdvertEntity.create({
    uuid: api.uuid,
    id: api.id,
    title: AdvertTitle.create(api.title),
    description: api.description,
    accountId: api.accountId,
    createdAt: new Date(api.createdAt),
    updatedAt: new Date(api.updatedAt),
  attachments: (api.attachments || []).map(a=> ({ uuid: a.id, url: a.url, type: a.type as any, position: a.position }))
  });
};
